<template>
  <div class="upSuccess">
    <p class="success">季报提交成功</p>
    <p class="routelink">
      <span class="time">{{time}}s</span>后自动跳转到季报列表
    </p>
    <el-button type="primary" @click="toReportList" class="mainBtn">返回季报列表</el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: 5
    };
  },

  mounted() {
    this.countToLink();
  },

  methods: {
    toReportList() {
      this.$router.push("/QuaReport/Record");
    },

    countToLink() {
      let time = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          clearInterval(time);
          this.toReportList();
        }
      }, 1000);
    }
  }
};
</script>

<style scoped>
.upSuccess {
  text-align: center;
  padding-top: 20%;
}
.success {
  font-size: 24px;
  color: #0f1824;
  margin: 16px 0px;
}

.routelink {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  color: #967f7f;
  text-align: center;
  line-height: 21px;
  margin-bottom: 10px;
}

.time {
  color: #3165ff;
}
</style>